import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-bonificacion',
  templateUrl: './btn-nuevo-tipo-bonificacion.component.html',
  styleUrls: ['./btn-nuevo-tipo-bonificacion.component.css']
})
export class BtnNuevoTipoBonificacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
